//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'
import CommentsDialog from './components/CommentsDialog'
import HsbcAPI from '@/api/promotores/hsbc.api'

export default {
  components: { ColumnsSelect, SearchInput },
  data() {
    return {
      visible_columns: [
        'id', 'nombre', 'email', 'celular', 'promotor', 'rfc', 'status', 'hsbc_product' ,'comentarios', 'created_at', 'updated_at'
      ],
      columns: [
        { name: 'id', field: 'id', label: 'ID', align: 'left' },
        { name: 'nombre', field: 'nombre_completo', label: 'Nombre', sortable: true, align: 'left' },
				{ name: 'email', field: 'email', label: 'Email', align: 'left' },
				{ name: 'celular', field: 'mobilephone', label: 'Celular', align: 'left' },
				{ name: 'rfc', field: 'rfc', label: 'RFC', align: 'left' },
				{ name: 'promotor', field: 'usuario', label: 'Promotor', sortable: true, align: 'left' },
				{ name: 'status', field: 'status', label: 'Estado', sortable: true, align: 'left' },
				{ name: 'hsbc_product', field: 'hsbc_product', label: 'Tipo credito', sortable: true, align: 'left' },
        { name: 'comentarios', label: 'Comentarios', field: 'comentarios' },
				{ name: 'created_at', field: 'created_at', label: 'Creado', sortable: true, align: 'left' },
				{ name: 'updated_at', field: 'updated_at', label: 'Actualizado', sortable: true, align: 'left' },
      ],
      contactos: [],
      status: [
       { value: 'contactado', label: 'Contactado' },
       { value: 'integracion', label: 'En proceso de integración' },
       { value: 'validacion_hsbc', label: 'Validación HSBC' },
       { value: 'aprobado', label: 'Aprobado' },
       { value: 'cancelado', label: 'Cancelado' },
      ],
      loading: false,
      filter: null,
    }
  },

  mounted() {
    this.loadContactos()
  },

  methods: {
    async loadContactos() {
      try {
        this.loading = true
        this.contactos = await HsbcAPI.all()
      } finally {
        this.loading = false
      }
    },
 
    async updateStatus(contacto){
      await HsbcAPI.update(contacto.id, {
         hsbc_status: contacto.status
        }) 
      this.loadContactos();       
    },

    async openComentariosDialog({ _id, nombre_completo, email, comentarios}) {
			this.$q.dialog({
				component: CommentsDialog,
				prospecto_id: _id,
				title: `Comentarios para ${nombre_completo}`,
				comentarios,
				organizacion_id: 'hsbc',
			})
				.onOk((comentario) => {
					comentarios.push(comentario);
				})
		},

  }
}
